<!-- prettier-ignore -->

@if(speaker.length === 1){
    <div class="event-qr-container">
        @for(item of speaker; track $index) {
            <div class="event-qr-container__single">
                <div class="event-qr-container__single__header">
                    @if(item?.speaker_img){
                        <img draggable="false" [src]="rest.apiUrlBase + item?.speaker_img" alt="speaker">
                    }
                    <span>{{item?.name}}</span>
                </div>
                <hr class="event-qr-hr">
                <div class="event-qr-container__single__body">
                    <span [innerHTML]="item?.description"></span>
                </div>
            </div>
        }
    </div>
}

@if(speaker?.length > 1){
    <div class="event-qr-container-multiple">
        @for(item of speaker; track $index; let last = $last) {
            <div class="event-qr-container-multiple__body">
                @if(item?.speaker_img){
                    <img draggable="false" alt="speaker" [src]="rest.apiUrlBase + item?.speaker_img">
                }
                <span>{{item?.name}}</span>
            </div>
            <div class="event-qr-container-multiple__footer">
                <span [innerHTML]="item?.description"></span>
            </div>
            @if(!last){
                <hr class="event-qr-hr">
            }
        }
    </div> 
}



